module.exports = {
    "Clear search": `Wyczy\u{15B}\u{107} zawarto\u{15B}\u{107} wyszukiwania`
};


//# sourceMappingURL=pl-PL.main.js.map
